export const detectDevice = (): { isMobile: boolean } => {
  if (!window) return null;

  const isMobile = Boolean(
    window.navigator.userAgent.match(/Android|BlackBerry|iPhone|Opera Mini|IEMobile|WPDesktop/i)
  );

  return { isMobile };
};
